import { render, staticRenderFns } from "./RemanentCard.vue?vue&type=template&id=6c9acb06&scoped=true"
import script from "./RemanentCard.vue?vue&type=script&lang=js"
export * from "./RemanentCard.vue?vue&type=script&lang=js"
import style0 from "./RemanentCard.vue?vue&type=style&index=0&id=6c9acb06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9acb06",
  null
  
)

export default component.exports